import { ContainerPointRanking } from 'models/ranking/pointRanking/ContainerPointRanking';
import { PointRankingService } from 'services/ranking/pointRanking/PointRankingService';

export class ContainerPointRankingService extends PointRankingService {
	toModel(ranking) {
		return new ContainerPointRanking(ranking);
	}
}
